<template>
  <div class="chat d-flex" v-bind:style="style">

    <div class="chat-main" v-if="connected">

      <div class="chat-header">
        <chat-header></chat-header>
      </div>

      <div class="chat-messages">
        <message-list></message-list>
      </div>

      <div class="chat-message-input">
        <message-input></message-input>
      </div>

    </div>

    <div class="chat-login-form align-self-center" v-else>
      <login-form></login-form>
    </div>

  </div>
</template>

<script>
import MessageInput from './MessageInput'
import MessageList from './MessageList'
import LoginForm from './LoginForm'
import ChatHeader from './Header'

import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'app',

  components: {
    MessageInput,
    MessageList,
    ChatHeader,
    LoginForm
  },

  computed: {
    ...mapGetters([
      'connected',
      'style'
    ])
  },

  methods: {
    ...mapMutations([
      'logout'
    ])
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/variables.scss';

.chat {
  background: $main-color;
  border: 1px solid $border-color;
  font-size: 0.9rem;

  &-main,
  &-login-form {
    width: 100%;
  }

  &-header {
    height: 10%;
    border-bottom: 1px solid $border-color;
  }

  &-messages {
    height: 80%;
    padding: 3%;
  }

  &-message-input {
    height: 10%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/App.vue